/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import Swiper from 'swiper';
import Component from 'can/component/component';
import template from './media-feed.stache';
import DomEventsManager from 'scripts/dom-events-manager';
import FeedService from 'scripts/services/base-feed-service';

import { prepareTimelineCards } from './media-feed.controller';

const timelinePlayerFeedUrl =
    window.globalSettings.feeds.timeline.playerFeedUrl;
const playerPageUrl = window.globalSettings.pagePaths.player;
const inWebView = _.get(window.globalSettings, 'inWebView');

Component.extend({
    tag: 'leader-board-media-feed',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            playerId: {
                type: 'string',
            },
            timeline: {
                Type: can.Map,
            },
            playerPageLatestPath: {
                get() {
                    let playerId = this.attr('playerId');
                    return (
                        can.sub(playerPageUrl, { playerId }) +
                        '#!section=tab-latest'
                    );
                },
            },
        },
    },
    events: {
        inserted: function() {
            const identifier = this.viewModel.playerId;
            const feedUrl = can.sub(timelinePlayerFeedUrl, {
                identifier: identifier,
                filter: 'all',
                index: 1,
            });
            this.playerFeedService = new FeedService({
                feedUrl,
                fromCache: true,
            });
            this.playerFeedService
                .on('fetching', (ev, value) => () => {
                    this.viewModel.attr('fetching', value);
                })
                .on('data', (ev, data) => {
                    let timeline = {};
                    if (data && data.cards && data.cards.length) {
                        timeline.cards = prepareTimelineCards(data.cards);
                        timeline.index = data.index;
                        timeline.total = data.total;
                    }
                    this.viewModel.attr('timeline', timeline);
                });

            this.playerFeedService.fetch({ identifier, index: 1 });
            DomEventsManager.subscribe(this);
        },
        removed: function() {
            DomEventsManager.unsubscribe(this);
            this.destroyFeedService();
        },
        destroyFeedService() {
            if (this.playerFeedService) {
                this.playerFeedService.destroy();
                this.playerFeedService = null;
            }
        },
        onLayout: function(layout) {
            if (layout === 'small' || layout === 'extra-small') {
                this.initSwiper(layout);
            } else {
                if (this.swiper) {
                    this.swiper.destroy(true, true);
                }
            }
        },
        initSwiper: function(screenSize) {
            let $swiperContainer = this.element.find('.swiper-container');
            if (this.swiper) {
                this.swiper.destroy(true, true);
            }

            this.swiper = new Swiper($swiperContainer, {
                simulateTouch: true,
                slidesPerView: 2,
                slidesPerGroup: 2,
                speed: 1000,
                pagination: {
                    el: $swiperContainer.find('.swiper-pagination'),
                    clickable: true,
                },
            });
        },
        getCardLink(card) {
            if (!card.shareUrl) {
                return null;
            }

            const cardPath = card.shareUrl.replace(/(\.mobile)?\.html$/, '');

            if (inWebView) {
                return `${cardPath}.mobile.html`;
            }

            return `${cardPath}.html`;
        },
        '.js-media-feed-link click'(element, event) {
            event.preventDefault();
            let card = this.viewModel.attr(
                `timeline.cards.${parseInt(element.attr('data-card-id'))}`,
            );

            let cardUrl = this.getCardLink(card);

            if (cardUrl) {
                if (card.type === 'articleCard' || card.type === 'photoCard') {
                    window.open(cardUrl, '_blank');
                }
            } else {
                console.warn('Card shareUrl not exists');
            }
        },
        '.js-media-feed-video click'(element) {
            const modalDialog = element.find('modal-dialog');
            if (modalDialog && modalDialog.length) {
                modalDialog.viewModel().show();
            }
        },
    },
});
